<!-- 销售订单 -->
<template>
   <div class='page_content'>
      <gyxnCancelOrderAction ref="gyxnCancelOrderAction"></gyxnCancelOrderAction>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false" :showRefresh="true"
            @getPageInfo="getPageInfo"></v-button>
         <div class="page_content_top_line">
            <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData"
               @openSearch="openSearch"></v-search>
         </div>
      </div>

      <div class="page_content_center">
         <el-table class="table1" stripe :data="returnData.list" :height="tableHeight" border style="width: 100%"
            highlight-current-row size="mini">
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="credate"
               label="取消日期"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="memo"
               label="取消原因"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="jobid" label="单号">
               <template slot-scope="scope">
                  <a @click="toDetail(scope.row.jobid)">{{
                     scope.row.jobid
                  }}</a>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="jobdtlid"
               label="明细单号"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="operationtype"
               label="业务类型"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="100" prop="jobflag" label="出入库标识">
               <template slot-scope="scope">
                  <el-tag size="mini" v-if="scope.row.jobflag == 0">入库业务</el-tag>
                  <el-tag size="mini" v-else-if="scope.row.jobflag == 1" type="success">出库业务</el-tag>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="100" prop="gyxnState" label="状态">
               <template slot-scope="scope">
                  <el-tag size="mini" v-if="scope.row.gyxnState == 0">初始</el-tag>
                  <el-tag size="mini" v-else-if="scope.row.gyxnState == 1" type="danger">已推送</el-tag>
                  <el-tag size="mini" v-else-if="scope.row.gyxnState == 2" type="success">成功</el-tag>
                  <el-tag size="mini" v-else-if="scope.row.gyxnState == -1" type="success">失败</el-tag>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="bgmName"
               label="通用名称"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="bgmCode"
               label="商品编号"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="bgpUnitmeasurement"
               label="包装单位"></el-table-column>
            <el-table-column prop="businessNum" label="订单数量" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="manufacturer" label="生产厂商" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="placeorigin" label="产地" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchno" label="批号" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="prodate" label="生产日期" min-width="130">
               <template slot-scope="scope">
                  <span class="ellipsis-cell">{{ $common.getLocalTime(scope.row.prodate) }}</span>
               </template>
            </el-table-column>
            <el-table-column prop="expidate" label="失效日期" min-width="130">
               <template slot-scope="scope">
                  <span class="ellipsis-cell">{{ $common.getLocalTime(scope.row.expidate) }}</span>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="msg"
               label="反馈结果"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="username"
               label="创建人"></el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
            @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData"
            @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue"
import indexJS from './gyxnCancelOrder';
import gyxnCancelOrderAction from "@/components/gyxnCancelOrderAction.vue";
export default {
   name: "gyxnCancelOrder",
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme,gyxnCancelOrderAction },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         searchList: indexJS.searchList,
         getRequestData: {
            unitName: "",//单位名称
            businessId: "",
            orderState: "",  //
            page: 1,
            rows: 30,
            start: '',	//开始上一个月
            end: '',	//当天最后时间
         },
         returnData: {
            pages: 0,  // 总页数
            total: 0,  // 总条数
            pageNum: 0,  // 当前页数
            list: []
         },
         sField: '',
         buttonList: [],
         selectedDataIndex: 0,
         seTitle: "",//检索
         DialogVisible: false,
         seWidth: '0',
         seId: 0,
         cmId: 0,
         parentSearchData: {},
         multipleSelection: []
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.cmName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.getRequestData.cmId = ''
            }
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页    
            var isPenetrate = true
            // 设置缓存 存入点击单号
            this.resetSetItem('penetrateOrderId', orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage({  //向窗口发送MessageEvent消息
               cmd: 'returnFormJson',
               params: { isPenetrate } //参数
            }, '*');
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         // console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      async getPageInfo() {

         var obj = this.$common.getSearchData(this.searchList, 'page', "rows", 30)
         for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
         }
         this.getButtonList()
         this.getDataList()
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.$refs['gyxnCancelOrderAction'].openBox(0, '')
               break;
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },


      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.gyxnCancelquery(this.getRequestData)
         if (responseData && responseData.status == 200) {
            let resData = JSON.parse(JSON.stringify(responseData))
            this.returnData.list = resData.result.list
            this.returnData.pages = resData.result.pages
            this.returnData.total = resData.result.total
            this.returnData.pageNum = resData.result.pageNum
            this.selectedDataIndex = 0

         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, '')
            let arr = JSON.parse(str)
            let len = arr.length
            let newStr = ''
            for (let i = 0; i < len; i++) {
               if (arr[i].key === val) {
                  newStr = arr[i].value
                  break;
               }
            }
            return newStr
         } catch (ex) {
            return str
         }
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
         console.log(this.buttonList);
      },
      initTime() {
         this.getRequestData.start = this.$common.getStartTime()
         this.getRequestData.end = this.$common.getEndTime()
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo()
      this.initTime()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

::v-deep .table1 tr td:first-child .cell,
::v-deep .table1 tr th:first-child .cell {
   text-align: center;
}

::v-deep .table1 .el-checkbox__inner {
   width: 18px;
   height: 18px;
}

::v-deep .table1 .el-checkbox__inner::after {
   height: 8px;
   left: 6px;
   top: 2px;
   width: 5px;
}

::v-deep .table1 .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
   height: 2px;
   left: 0;
   right: 0;
   top: 7px;
}
</style>
